export default __webpack_public_path__ + "static/media/goshen79.ff207b95.jpg";